var isNumber = require('../type/is-number');

var isNagative = function isNagative(num) {
  return isNumber(num) && num < 0;
};

module.exports = isNagative;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@antv/util/lib/math/is-negative.js
// module id = 298
// module chunks = 0 1 2